import React from "react";
import HeaderLoggedIn from '../components/HeaderLoggedIn'
import './Content.scss';
import InstagramEmbed from 'react-instagram-embed';

class Content3 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        return (
            <div className="content">
                <HeaderLoggedIn />
                <img src="/content-logo-3.jpg"></img>
                <h1>ต้อนรับปี 2020 ด้วยแฟชั่นสี Classic Blue ที่ Pantone เลือกให้เป็นสีแห่งปี</h1>
                <div className="contentBody container">
                    <p>
                        เข้าใกล้ปี 2020 เข้าไปทุกที เราก็ขอต้อนรับเทรนใหม่ด้วยสีประจำปีอย่างสี Classic Blue 19-4052 ที่สื่อถึงความสงบ และเชื่อมั่น แต่ถึงจะมีความหมายที่สื่อถึงความเรียบง่าย แต่สี Classic Blue มีอีกความหมายหนึ่งคือ ไร้ซึ่งกาลเวลา (Timeless) สามารถนำมา Mix & Match ได้เท่สุด ๆ ไม่มีเอ้าท์ แถมแต่งได้หลาหลายสไตล์ ใครที่รู้ตัวว่าป็นสายแฟชั่นนิสต้าต้องมีติดตู้ไว้สักตัวสองตัวแล้ว ไม่อย่างงั้นจะให้ว่าไมเตือนไม่ได้นะ!
                    </p>
                    <br />
                    <p>
                        1.เสื้อสี Classic Blue สำหรับสาวที่รักในความเรียบง่าย
                    </p>
                    <InstagramEmbed
                        url='https://www.instagram.com/p/B0AcyoBAfkF/'
                        maxWidth={320}
                        hideCaption={false}
                        containerTagName='div'
                        protocol=''
                        injectScript
                        onLoading={() => { }}
                        onSuccess={() => { }}
                        onAfterRender={() => { }}
                        onFailure={() => { }}
                    />
                    <p>
                        เริ่มด้วยเสื้อผ้าโทนสีน้ำเงินที่ต้องเหล่าสายแฟชั่นต้องมีติดตู้ เพราะเป็นที่รู้กันดีว่าสีน้ำเงินใส่แล้วจะขับผิวสุด ๆ ทั้งนี้เรายังสามารถนำมามิกซ์กับกระโปงสุดน่ารักก็ได้ หรือแมทช์กับเกงเกงสุดคูลก็ดี รับรองว่ามีติดตู้ไว้ได้ใช้แน่นอน
                    </p>
                    <br />
                    <p>
                        2.กางเกงสี Classic Blue สำหรับสาว ๆ ที่ชอบความกระฉับกระเฉง
                    </p>
                    <InstagramEmbed
                        url='https://www.instagram.com/p/B4_UzmYnE37/'
                        maxWidth={320}
                        hideCaption={false}
                        containerTagName='div'
                        protocol=''
                        injectScript
                        onLoading={() => { }}
                        onSuccess={() => { }}
                        onAfterRender={() => { }}
                        onFailure={() => { }}
                    />
                    <p>
                        มาต่อด้วยเกงเกงโทนสีนำเงิน ที่ใส่แล้วดูเท่แต่แอบซ่อนความน่ารักไว้ในเวลาดียวกัน ได้ทั้งลุค Working Women ผสมความเป็นแฟชั่นนิสต้าหน่อย ๆ หรือจะใส่เป็นกางเกงวอร์มก็ให้ลุค Street Girl สไตล์สาวซ่ารับรองว่าปังสุด ๆ แบบนี้ไม่มีไม่ได้แล้วนะ!
                    </p>
                    <br />
                    <p>
                        3.เสื้อคุลมสี Classic Blue เรียบหรูดูแพงสำหรับสาวมั่นที่รักแต่งตัว
                    </p>
                    <InstagramEmbed
                        url='https://www.instagram.com/p/B55002Vn0me/'
                        maxWidth={320}
                        hideCaption={false}
                        containerTagName='div'
                        protocol=''
                        injectScript
                        onLoading={() => { }}
                        onSuccess={() => { }}
                        onAfterRender={() => { }}
                        onFailure={() => { }}
                    />
                    <p>
                        เสื้อคลุมสีน้ำเงินที่แมทช์กับสีอะไรก็เกิด จำคู่กับสีอะไรก็เกิด อย่างเสื้อสูทก็จะได้ลุคเรียบหรูดูแพง เหมาะกับสาวมั่นไปออกงานสังคม รับรองโดดเด่นจนทุกคที่ต้องเหลียวหลังมองอย่างแน่นอน หรือถ้าหากใครชอบเปลี่ยนสไตล์ไปตามเทรนล่ะก็ เราขอแนะนำให้หาเสื้อคลุม คาดิแกนสีน้ำเงินติดตู้เสื้อผ้าไว้สักตัว นำมา Mix & Match ได้ทุกสไตล์ ใส่ได้ทุกวันไม่ซ้ำกันแน่นอน
                    </p>
                    <br />
                    <p>
                        4.เดรส Classic Blue สำหรับสาว ๆ ที่รักในความเป็นผู้หญิง
                    </p>
                    <InstagramEmbed
                        url='https://www.instagram.com/p/B5jnbSLHQeE/'
                        maxWidth={320}
                        hideCaption={false}
                        containerTagName='div'
                        protocol=''
                        injectScript
                        onLoading={() => { }}
                        onSuccess={() => { }}
                        onAfterRender={() => { }}
                        onFailure={() => { }}
                    />
                    <p>
                        สุดท้ายกับแฟชั่นชุดเดรส แฟชั่นสุดโปรดสำหรับสาว ๆ หลายคน เพราะนอกจากใส่แล้วดูขับผิวให้สว่างแล้ว ยังส่งให้ดูเป็นสาวหวานน่ารักน่าทะนุถนอม หรือถ้าหากอยากดูเท่ห์ก็สามารถหาเดรสหนังมันเงาที่จะเปลี่ยนลุคของสาว ๆ ดูเท่และสง่างามสุด ๆ ไปเลย
                    </p>
                    <br />
                    <p>
                        สี Classic Blue นอกจากจะเป็นสียอดฮิตของปี ยังเป็นสีทีนำมา Mix & Match ได้หลายแบบหลายสไตล์อีกต่างหาก ถ้าหากไม่อยากตกเทรนก็รีบหามาไว้แต่งได้แล้วนะ สำหรับใครที่ยังไม่มีก็กดค้นหาสินค้ากับ OUT-FIT ได้เลย หรือถ้าหากไม่อยากซื้อใหม่ก็สามารถนำเสื้อผ้าตัวเก่าของสาว ๆ มากดแลกเปลี่ยนในเว็บไซต์ของเราได้เลย อะไรจะดีขนาดนี้ !
                    </p>
                </div>
            </div>
        )
    }
}

export default Content3;